import React, { Component } from 'react';

class Social extends Component {
    render() {
        return (
            <div className='d-inline-block'>
                <div className="social inline-block">
                    <a href='https://facebook.com/faysalchowdhury99' target="_blank" rel="noreferrer"><i className={this.props.firstChild}></i></a>
                    <a href='https://instagram.com/faysalchowdhury99' target="_blank" rel="noreferrer"><i className='fa fa-instagram'></i></a>
                    <a href='https://twitter.com/faysalchowdhury99' target="_blank" rel="noreferrer"><i className='fa fa-twitter'></i></a>
                    <a href='https://linkedin.com/faysalchowdhury99' target="_blank" rel="noreferrer"><i className='fa fa-linkedin'></i></a>
                    <a href='https://github.com/faysalchowdhury99' target="_blank" rel="noreferrer"><i className='fa fa-github'></i></a>
                </div>
            </div>
        );
    }
}

export default Social;